import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Icon } from '../components/Icons';
import '../styles/Password-reset.css';

const ResetPassword = ({ username: propUsername }) => {
  const [searchParams] = useSearchParams();
  const username = propUsername || searchParams.get("username") || "";
  const [form, setForm] = useState({ newPassword: '', confirmPassword: '' });
  const [message, setMessage] = useState({ text: '', type: '' });
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.newPassword || !form.confirmPassword) {
      setMessage({ text: 'Please fill in both fields.', type: 'error' });
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      setMessage({ text: 'Passwords do not match.', type: 'error' });
      return;
    }
    try {
      const response = await fetch("/timesheets/resetPassword", {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userName: username, password: form.newPassword }),
      });
      const result = await response.text();
      setMessage({ text: result, type: response.ok ? 'success' : 'error' });
      if (response.ok) setForm({ newPassword: '', confirmPassword: '' });
    } catch (error) {
      console.error('Error during password reset:', error);
      setMessage({ text: 'An error occurred. Please try again.', type: 'error' });
    }
  };

  return (
    <div className="pr-page">

      {/* Left panel */}
      <div className="pr-left">
        <div className="pr-brand">
          <div className="pr-brand-icon-wrap">
            <Icon.Lock size={36} color="#fff" strokeWidth={1.5} />
          </div>
          <h1>Reset Password</h1>
          <p>Choose a strong, unique password to keep your account secure.</p>
        </div>
      </div>

      {/* Right card */}
      <div className="pr-right">
        <div className="pr-card">
          <div className="pr-card-icon-wrap">
            <Icon.Lock size={26} color="#3730a3" strokeWidth={1.5} />
          </div>
          <h2>New Password</h2>
          <p className="pr-card-sub">Create a new password for <strong>{username}</strong></p>

          <div className="pr-field">
            <label className="pr-label" htmlFor="rp-new">New Password</label>
            <div className="pr-input-wrap">
              <span className="pr-input-icon"><Icon.Lock size={15} color="#94a3b8" /></span>
              <input
                id="rp-new"
                name="newPassword"
                type={showNewPassword ? 'text' : 'password'}
                className="pr-input"
                placeholder="Enter new password"
                value={form.newPassword}
                onChange={handleChange}
                autoComplete="new-password"
              />
              <button type="button" className="pr-eye-btn" tabIndex={-1}
                onClick={() => setShowNewPassword(v => !v)}
                aria-label={showNewPassword ? 'Hide password' : 'Show password'}>
                {showNewPassword ? <Icon.EyeOff size={15} color="#94a3b8"/> : <Icon.Eye size={15} color="#94a3b8"/>}
              </button>
            </div>
          </div>

          <div className="pr-field">
            <label className="pr-label" htmlFor="rp-confirm">Confirm Password</label>
            <div className="pr-input-wrap">
              <span className="pr-input-icon"><Icon.CheckCircle size={15} color="#94a3b8" /></span>
              <input
                id="rp-confirm"
                name="confirmPassword"
                type={showConfirmPassword ? 'text' : 'password'}
                className="pr-input"
                placeholder="Confirm new password"
                value={form.confirmPassword}
                onChange={handleChange}
                autoComplete="new-password"
              />
              <button type="button" className="pr-eye-btn" tabIndex={-1}
                onClick={() => setShowConfirmPassword(v => !v)}
                aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}>
                {showConfirmPassword ? <Icon.EyeOff size={15} color="#94a3b8"/> : <Icon.Eye size={15} color="#94a3b8"/>}
              </button>
            </div>
          </div>

          {message.text && (
            <div style={{
              padding: '10px 14px',
              borderRadius: 11,
              marginBottom: 14,
              fontSize: '0.84rem',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              background: message.type === 'success' ? '#f0fdf4' : '#fff1f2',
              color: message.type === 'success' ? '#16a34a' : '#e11d48',
              border: `1px solid ${message.type === 'success' ? '#bbf7d0' : '#fecdd3'}`,
            }}>
              {message.type === 'success' ? '🎉' : '⚠️'} {message.text}
            </div>
          )}

          <button className="pr-btn" onClick={handleSubmit}>
            Reset Password <Icon.ArrowRight size={17} color="#fff" style={{ marginLeft: 4 }} />
          </button>

          <div className="pr-back">
            <Link to="/login">
              <Icon.ChevronRight size={14} color="#3730a3" style={{ transform: 'rotate(180deg)', marginRight: 4 }} />
              Back to Login
            </Link>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ResetPassword;
